import React from 'react'
import Avatar from "@mui/material/Avatar"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import LockIcon from "@mui/icons-material/Lock"
import image from "../assets/result.svg"
import { Link } from "react-router-dom"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import { Formik, Form } from "formik"
import { object, string } from "yup"
import useAuthCall from '../hooks/useAuthCall'
import { useState } from 'react'
import packageJson from "../../package.json"
import lock from "../assets/img/lock.png"
import { colors } from '../styles/globalStyle'
import { useSelector } from 'react-redux'

const Login = () => {


  const [info, setInfo] = useState({
    username: "",
    password: ""
  })

  const { signIn,login } = useAuthCall()
  const {loading} = useSelector((state)=>state.auth)

  const handleChange = (e) => {
    setInfo({ ...info, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {

    e.preventDefault()

    login(info)
    // signIn(info)

    setInfo({
      username: "",
      password: ""
    })
  }

  

  return (


    <Box sx={{ p: 3, height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: colors.loginBg }}>

      <Typography variant='h4' align='center' p={3} fontWeight={700} color={colors.beyaz}>Bonna Çayırova Proses</Typography>

      <Container
        maxWidth='sm'
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 3 }}
        component={'form'}
        onSubmit={handleSubmit}
      >
        <img
          src={lock}
          width={40}
          style={{ margin: 'auto' }}
        />

        <Typography
          sx={{
            letterSpacing: 5,
            color: colors.mavi,
            fontWeight: 700
          }}
          align='center'
        >
          LOGIN
        </Typography>

        <TextField
          required
          name='username'
          id='username'
          type='text'
          variant='filled'
          label='Username'
          onChange={handleChange}
          value={info.username}
          sx={{
            '& .MuiInputBase-root': {
              borderRadius: '8px',
              backgroundColor: colors.beyaz,
              color: '#000000',
              '&:hover': {

                backgroundColor: colors.beyaz
              },
              '& .MuiInputBase-input': {
                borderRadius: '8px',
                backgroundColor: colors.beyaz,
                // '&:hover': {
                //     borderRadius: '8px',
                //     backgroundColor: colors.beyaz
                // }
              }
            },
          }}
        />
        <TextField
          required
          name='password'
          id='password'
          type='password'
          variant='filled'
          label='Password'
          onChange={handleChange}
          value={info.password}
          sx={{
            '& .MuiInputBase-root': {
              borderRadius: '8px',
              backgroundColor: colors.beyaz,
              color: '#000000',
              '&:hover': {

                backgroundColor: colors.beyaz
              },
              '& .MuiInputBase-input': {
                borderRadius: '8px',
                backgroundColor: colors.beyaz,
                // '&:hover': {
                //     borderRadius: '8px',
                //     backgroundColor: colors.beyaz
                // }
              }
            },
          }}
        />

          {
            loading ?
            (<div className='btnLoginLoader' style={{ margin: 'auto' }}></div>)
            :
            (
              <Button variant='contained' type='submit' sx={{ letterSpacing: 3 }}> Login </Button>
            )
          }

        <Typography variant='subtitle2' align='center' color={colors.gri}>v{packageJson.version}</Typography>

      </Container>

    </Box>

  )
}

export default Login